import flatpickr from 'flatpickr';
import { Arabic } from 'flatpickr/dist/l10n/ar.js';

flatpickr.localize(Arabic);

export default flatpickr;
